import React from 'react';
import Google from '../../assets/images.png'

const GoogleReviewBanner = () => {
  return (
    <div className="bg-zinc-900/80 text-white  flex flex-col md:flex-row items-center justify-between container p-[40px]">
      {/* <p className="text-white font-bold text-lg md:text-xl text-center md:text-left">
        Toni hat 4,9 Sterne und über 100 Bewertungen
      </p> */}

      <div className="flex items-center mt-2 md:mt-0">
        <img
          src={Google}
          alt="Google Logo"
          className="h-5 mr-2"
        />

        <div className="flex items-center space-x-1 mr-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <svg key={i} className="w-4 h-4 fill-yellow-400" viewBox="0 0 24 24">
              <path d="M12 .587l3.668 7.568L24 9.423l-6 5.847 1.417 8.263L12 18.897 4.583 23.533 6 15.27 0 9.423l8.332-1.268z" />
            </svg>
          ))}
        </div>

        <span className="text-white text-sm font-semibold">4.9 /  über 200 Bewertungen</span>
      </div>
    </div>
  );
};

export default GoogleReviewBanner;
